import OrderStatusSummary from "./OrderStatusSummary/OrderStatusSummary";
import DashboardSummary from "./dashboardSummary/DashboardSummary";
import StockRequestsSummary from "./StockRequestsSummary/StockRequestsSummary";
import Graph from "./graph/Graph";
import DaySwitch from "./daySwitch/DaySwitch";

export {
  OrderStatusSummary,
  DashboardSummary,
  Graph,
  StockRequestsSummary,
  DaySwitch
};



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js